#import "../fragments/nutshell-marketing-stats.graphql"

query GetNutshellMarketingStats {
    nutshellMarketingStats {
        ...NutshellMarketingStats
    }
}
